import Isotope from 'isotope-layout';
import { createLogicalAnd } from 'typescript';

const filterContainer = document.querySelector('.filter-container');

if (filterContainer) {
  const iso = new Isotope(filterContainer, {
    itemSelector: '.filter-item',
    layoutMode: 'fitRows',
    transitionDuration: '0s',
    transformsEnabled: false,
  });

  const defaultFilter = filterContainer.getAttribute('data-default-filter');

  if (defaultFilter) {
    iso.arrange({ filter: '.' + defaultFilter });
  }

  const filterControls = document.querySelectorAll('.filter-grid__control');
  const filterSelect = document.getElementById('filter-grid__select') as HTMLSelectElement;

  filterControls.forEach((link) => {
    link.addEventListener('click', (event) => {
      const filter = link.getAttribute('data-filter');

      for (let index = 0; index < filterControls.length; index++) {
        filterControls[index].classList.remove('active');
      }

      link.classList.add('active');

      iso.arrange({ filter: '.' + filter });
    });
  });

  filterSelect.addEventListener('change', () => {
    const filter = filterSelect.value;
    iso.arrange({ filter: '.' + filter });
  });
}
